module.exports = __webpack_public_path__ + "img/744.ebcbaeb8.jpg";